(() => {
  if (customElements.get('zardo-collection-count')) return;

  class CollectionCount extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      document.addEventListener('facet:update', event => this.refresh(event.detail.url), { signal: this.events.signal });
      window.addEventListener('popstate', () => this.refresh(location.href), { signal: this.events.signal });
      const initial = this.querySelector('[data-zardo-count-page]');
      if (Number(initial?.dataset.pages) > 1) this.refresh(location.href);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
    }

    async refresh(source) {
      this.request?.abort();
      const request = this.request = new AbortController();
      this.textContent = 'Products';
      this.setAttribute('aria-busy', 'true');
      let url = new URL(source, location.href);
      url.searchParams.set('section_id', 'zardo-collection-count');
      url.searchParams.set('page', '1');
      let total = 0;
      const visited = new Set();
      try {
        while (url) {
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid count pagination');
          visited.add(url.href);
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Count request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const batch = doc.querySelector('[data-zardo-count-page]');
          const count = Number(batch?.dataset.count);
          if (!batch || !Number.isInteger(count) || count < 0) throw new Error('Invalid count response');
          total += count;
          url = batch.dataset.next ? new URL(batch.dataset.next, url) : null;
          if (url) url.searchParams.set('section_id', 'zardo-collection-count');
        }
        if (!request.signal.aborted) this.textContent = `${total} ${total === 1 ? 'product' : 'products'}`;
      } catch (error) {
        // Do not show a partial total when a page could not be counted.
        if (error.name !== 'AbortError' && !request.signal.aborted) this.textContent = 'Products';
      } finally {
        if (!request.signal.aborted) this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('zardo-collection-count', CollectionCount);
})();
